import styles from "./TableBody.module.scss";
import { Checkbox } from "@/frontend/shared/ui/Checkbox";
import { Dispatch, SetStateAction, useState } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { buildCells } from "../RowCell/RowCell";
import { getRouteCompanyProfile, getRouteExpertCompanyProfile } from "@/frontend/shared/const/router";
import { TCompaniesDataResponse } from "../../model/types/types";
import { Typography } from "@/frontend/shared/ui/Typography";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { extractOrganizationId } from "@/frontend/shared/lib/extractOrganizationId/extractOrganizationId";
import { Pagination } from "../Pagination/Pagination";

type TTableBody = {
  selected: number[];
  onChange: (id: number) => void;
  data: TCompaniesDataResponse;
  triggerRefetch: () => void;
  companyHeaders?: { value: string; label: string }[];
  limit: number;
  setPage: Dispatch<SetStateAction<number>>;
  currentPage: number;
  isLoading: boolean;
  isFounder?: boolean;
};

export function TableBody({
  selected,
  onChange,
  data,
  triggerRefetch,
  isLoading,
  limit,
  setPage,
  currentPage,
  isFounder
}: TTableBody) {
  const [shownModal, setShownModal] = useState<{ type: string; id: number | null }>({ type: "", id: null });
  const { navigate } = useHistoricalNavigate();

  const { pathname } = useLocation();
  const organizationId = extractOrganizationId(pathname) || null;

  switch (true) {
    case isLoading:
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    case !!data?.companies?.length:
      return (
        <>
          <div className={styles.cardContainer}>
            {data?.companies?.map((portfolioCompany, index) => {
              return (
                <div
                  key={index}
                  className={clsx(styles.card, isFounder && styles.isFounderCard)}
                  onClick={() =>
                    navigate(
                      organizationId
                        ? getRouteExpertCompanyProfile(organizationId, portfolioCompany.id)
                        : getRouteCompanyProfile(portfolioCompany.id)
                    )
                  }
                >
                  {!isFounder && (
                    <div className={styles.checkboxContainer}>
                      <Checkbox
                        value={selected.includes(portfolioCompany.id)}
                        onChange={() => onChange(portfolioCompany.id)}
                        className={clsx("discoverPage-companyCheckbox", styles.checkbox)}
                      />
                    </div>
                  )}
                  {buildCells(portfolioCompany, isFounder)}
                </div>
              );
            })}
          </div>
          <div className={styles.paginationContainer}>
            <Pagination
              setPage={setPage}
              companiesLimit={limit}
              companiesTotal={data.totalCompanies}
              currentPage={currentPage}
              className={styles.pagination}
              isLoading={isLoading}
            />
          </div>
        </>
      );
    default:
      return (
        <div className={styles.emptyPageContainer}>
          <Typography variant="label-4" color="greyscale600">
            No matching companies found
          </Typography>
        </div>
      );
  }
}
